import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import TabPanel from 'components/consumer/TabPanel';
import { trackProductInfoSectionSelected } from 'data-hooks/useEvents/pdpInteractionEvents';
import usePDPInfoSections from '../PDPInfoSections/usePDPInfoSections';
const PDPInfoTabsInner = () => {
  const $ = _c(11);
  const items = usePDPInfoSections();
  const [chosenTab, setChosenTab] = useState(null);
  if (!items.length) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="PDPInfoTabs__filler" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== chosenTab || $[2] !== items) {
    t0 = items.some(t1 => {
      const {
        id
      } = t1;
      return id === chosenTab;
    }) ? chosenTab : items[0].id;
    $[1] = chosenTab;
    $[2] = items;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const selectedTab = t0;
  let t1;
  if ($[4] !== items || $[5] !== selectedTab) {
    t1 = id_0 => {
      setChosenTab(id_0);
      if (id_0 !== selectedTab) {
        trackProductInfoSectionSelected(items.find(item => item.id === id_0).section);
      }
    };
    $[4] = items;
    $[5] = selectedTab;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const selectTab = t1;
  let t2;
  if ($[7] !== items || $[8] !== selectTab || $[9] !== selectedTab) {
    t2 = <div className="mt-12" data-xc="PDPInfoTabs"><TabPanel aria-label="Product information" items={items} selectedTab={selectedTab} onSelectTab={selectTab} variant="underline" tabContentClassNamesOverride="pt-8" /></div>;
    $[7] = items;
    $[8] = selectTab;
    $[9] = selectedTab;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
const PDPInfoTabs = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SuspenseWithLoader><PDPInfoTabsInner /></SuspenseWithLoader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPInfoTabs;